<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-18 16:15:18
 * @LastEditTime: 2019-06-18 16:15:18
 * @LastEditors: your name
 -->
<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-select v-model="envId" placeholder="请选择环境" clearable filterable @change="changeEnvId">
          <el-option
            v-for="item in envOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="appName" placeholder="请选择项目" clearable filterable @change="changeAppName">
          <el-option
            v-for="item in caseOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showCharts">刷新</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ['showCharts'],
  data() {
    const self = this;
    return {
      envOptions: [{
        label: '全部',
        value: ''
      }, {
        label: '开发环境',
        value: 'dev'
      }, {
        label: '测试环境',
        value: 'test'
      }, {
        label: '预发环境',
        value: 'pre'
      }, {
        label: '生成环境',
        value: 'prod'
      }],
      caseOptions: [{
        label: '全部',
        value: ''
      }],
      envId: '',
      appName: ''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fetchCaseList();
      this.showCharts();
    },
    fetchCaseList() {
      return axios
        .get(`/publish/caseList`)
        .then(response => {
          const { data } = response.data;

          data.map(item => {
            this.caseOptions.push({
              label: item.appName,
              value: item.appName
            })
          })
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeEnvId(envId) {
      this.$emit('update:params', {
        envId,
        appName: this.appName,
      });

      this.showCharts();
    },
    changeAppName(appName) {
      this.$emit('update:params', {
        envId: this.envId,
        appName
      });

      this.showCharts();
    }
  }
}
</script>
